export const ENV = {
  VONAGE_API_KEY: process.env.REACT_APP_VONAGE_API_KEY ?? "",
};
